import { useRef, useState } from 'react';
import './poke.css';
import Background from './background';
import PokeCards from './pokeCards';

export default function PokePage() {
  const pageRef = useRef(null);
  const [showInfo, setShowInfo] = useState(false);

  return (
    <main className="poke-page" ref={pageRef}>
      <Background />
      <button
        type="button"
        className="poke-page__info-button"
        aria-expanded={showInfo}
        aria-controls="poke-page-tech-info"
        aria-label={showInfo ? 'Hide technical details' : 'Show technical details'}
        onClick={() => setShowInfo((current) => !current)}
      >
        i
      </button>
      {showInfo ? (
        <aside className="poke-page__info-panel" id="poke-page-tech-info">
          <h2>How This Page Works</h2>
          <p>
            The frontend is a React page that fetches card data from the backend which was created in Go. The backend serves a JSON snapshot of the portfolio through the
            <code> /poke </code>
            endpoint.
          </p>
          <p>
            The background is comprised of animated sprites that move across the screen. An individual sprite is chosen from a random sprite across multiple generations of pokemon, creating a unique background every time.
          </p>
          <p>
            Cards are rendered in batches for smoother scrolling, and the animated sprite
            background is positioned separately from the card grid so the UI can stay
            responsive.
          </p>
          <p>
            Layout, styling, and interactions on this screen are driven with plain React
            components, CSS, and a small API helper module for the local fetch call.
          </p>
        </aside>
      ) : null}
      <div className="poke-page__content">
        <section className="poke_page__intro">
          <h1>My Card Portfolio</h1>
          <p>
            A collection of the Pokemon cards I have collected along with a few One Piece cards. Press the info icon in the top left
            to see the technical details of how the page was built.
          </p>
        </section>
        <PokeCards />
      </div>
    </main>
  );
}
